import { faFacebookF, faInstagram, faTelegram, faViber } from '@fortawesome/free-brands-svg-icons';

/**
 * Оформлення соцмереж за ключем `network` із бекенда (api::contact-info).
 *
 * CMS зберігає лише мережу й посилання — назву, іконку та колір наведення
 * підбирає фронтенд, щоб редактор в адмінці обирав мережу зі списку, а не
 * вставляв SVG чи HEX-код.
 */
export const SOCIAL_NETWORKS = {
  facebook: { label: 'Facebook', icon: faFacebookF, hoverColor: '#1877F2' },
  instagram: { label: 'Instagram', icon: faInstagram, hoverColor: '#E1306C' },
  telegram: { label: 'Telegram', icon: faTelegram, hoverColor: '#26A5E4' },
  viber: { label: 'Viber', icon: faViber, hoverColor: '#7360F2' },
};
